import React, {memo} from 'react'
import {InputLabel, MenuItem, FormControl, Select} from '@material-ui/core'
import clsx from 'clsx'

import {useTranslation} from 'react-i18next'
import useStyles from './styles'

interface SelectControlProps<T> {
  selectedItem: string | number
  items: T[]
  title: string
  onHandleChange: (
    event: React.ChangeEvent<{
      name?: string
      value: unknown
    }>,
  ) => void
  variant?: 'outlined' | 'standard' | 'filled'
  translateKeyForValues?: string
  fullWidth?: boolean
  keyId?: keyof T
  keyValue?: keyof T
}

function SelectControlComponent<T>({
  selectedItem,
  items,
  title,
  onHandleChange,
  variant = 'outlined',
  fullWidth = false,
  translateKeyForValues,
  keyId = 'value' as keyof T,
  keyValue = 'text' as keyof T,
}: SelectControlProps<T>) {
  const classes = useStyles()
  const {t} = useTranslation()
  return (
    <FormControl size="small" variant={variant} className={clsx(fullWidth && classes.fullWidth)}>
      <InputLabel id="forecast-select-outlined-label">{title}</InputLabel>
      <Select
        labelId="forecast-select-outlined-label"
        id="forecast-select"
        value={selectedItem}
        onChange={onHandleChange}
        label={title}
      >
        {items.map(item => {
          const key = item[keyId] as string | number
          return (
            <MenuItem key={key} value={key}>
              {translateKeyForValues
                ? t(`${translateKeyForValues}:${item[keyValue]}` as string)
                : item[keyValue]}
            </MenuItem>
          )
        })}
      </Select>
    </FormControl>
  )
}

export default memo(SelectControlComponent) as typeof SelectControlComponent
